import { Container, H3, P1 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import FeesCalculator from 'modules/discover/PlatformPageNew/Calculator/FeesCalculator/FeesCalculatorContainer'

import styles from './Calculator.module.scss'

const Calculator = ({ urlSlug, title, text, feesCalc, minInvestment, termCalculator, target }) => (
  <Container width={1230} className={styles.Calculator}>
    <div className={styles.Header}>
      <H3 weight="semibold" id={urlSlug}>
        {title}
      </H3>
      <P1>{text}</P1>
    </div>

    <FeesCalculator fees={feesCalc} minInvestment={minInvestment} termCalculator={termCalculator} target={target} />
  </Container>
)

Calculator.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  urlSlug: PropTypes.string,
  feesCalc: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minInvestment: PropTypes.number,
  termCalculator: PropTypes.number,
  target: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    max: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })
}

Calculator.defaultProps = {
  title: '',
  text: '',
  feesCalc: 1,
  termCalculator: 0,
  minInvestment: 1000,
  urlSlug: '',
  target: {
    min: 8
  }
}
export default Calculator
